<script setup lang="ts">
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import type { VForm } from 'vuetify/components/VForm'
import { VCardTitle } from "vuetify/lib/components/index.mjs";

import type { DeTableProperties } from '@/pages/erp/de/select/db/de-table-types'
import type { De23Properties } from '@/pages/erp/de/select/db/de-select-types'

definePage({
  meta: {
    action: 'manage',
    subject: 'DETABLE',
  },
})

const router = useRouter()
const route = useRoute('erp-de-select-view-tab-id')

const goBack = () => {
  router.push({ name: 'erp-de-select-view-de-table' })
}

const tabId = ref(route.params.tabId)

const compId =  ref(useStorage('compNo', 'nstc').value)


const isFormValid = ref(false)
const refForm = ref<VForm>()

const deTableForm = reactive({
  tabId: '',
  tabName: '',
  tabComment: '',
  stru1From: '',
  stru1To: '',
  stru1Desc: '',
  stru2From: '',
  stru2To: '',
  stru2Desc: '',
  stru3From: '',
  stru3To: '',
  stru3Desc: '',
  stru4From: '',
  stru4To: '',
  stru4Desc: '',
  stru5From: '',
  stru5To: '',
  stru5Desc: '',
  field1Name: '欄位一',
  field2Name: '欄位二',
  field3Name: '欄位三',
  field4Name: '欄位四',
  auth1Id: '',
  auth2Id: '',
  auth3Id: '',
  auth4Id: '',
  auth5Id: '',
  creatorId: 'ICSC01',
  createDate: '',
  compId: useStorage('compNo', '').value, 
  isUniCompId: '',
})

const deSelectForm = reactive({
  tabId: '',
  compId: useStorage('compNo', '').value, 
  field1: '',
  field2: '',
  field3: '',
  field4: '0',
  createDate: '',
  creatorId: '',
})


// 👉 Fetching data
const { data: deTableData, execute: fetchDeTable } = await useApi<any>(createUrl('/de/select/table/loadDeTable', {
    query: {
      tabId,compId,
    },
}))

if (deTableData.value) {
  deTableForm.tabId = deTableData.value.data.deTable.tabId
  deTableForm.tabName = deTableData.value.data.deTable.tabName
  deTableForm.tabComment = deTableData.value.data.deTable.tabComment
  deTableForm.field1Name = deTableData.value.data.deTable.field1Name
  deTableForm.field2Name = deTableData.value.data.deTable.field2Name
  deTableForm.field3Name = deTableData.value.data.deTable.field3Name
  deTableForm.field4Name = deTableData.value.data.deTable.field4Name
}

const onSubmit = () => {
  refForm.value?.validate().then(({ valid }) => {
    if (valid) {
      if (tabId.value == 'newData') {
        addNewDeTableData()
      } else {
        updateDeTableData()
      }
    }
  })
}


// 👉 Add new data
const addNewDeTableData = async () => {
  await $api('/de/select/table/createDeTable', {
    method: 'POST',
    body: { deTable: deTableForm },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '新增成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  router.push({ name: 'erp-de-select-view-tab-id', params: { tabId: deTableForm.tabId } }).then(() => {
      tabId.value = deTableForm.tabId
  })
}

// 👉 Delete data
const deleteDeTableData = async () => {
  const { tabId,compId } = deTableData.value
    $swal({
    title: `確定要刪除 ${tabId} 資料?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消",
    reverseButtons: true
  }).then((result) => {
    if (result.isConfirmed) {
        $api(`/de/select/table/deleteDeTable`, {
        method: 'DELETE',
        query: {
            tabId,compId
        }
      }).then(() => {
          $swal({
          position: 'top-end',
          title: "刪除成功",
          timer: 1500,
          icon: "success"
        });

        router.push({ name: 'erp-de-select-view-tab-id', params: { tabId: 'newData' } })
      })
    }
  });

}

const updateDeTableData = async () => {
  await $api('/de/select/table/updateDeTable', {
    method: 'PUT',
    body: { deTable: deTableForm },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '修改成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchDeTable()
}


  const grid1Headers = [
    { title: 'TAB編號', key: 'tabId' },
  ]

  const grid2Headers = computed(() => [
    { title: deTableForm.field1Name??'欄位1', key: 'field1', minWidth: '200px' },
    { title: deTableForm.field2Name??'欄位2', key: 'field2', minWidth: '400px' },
    { title: deTableForm.field3Name??'欄位3', key: 'field3', minWidth: '400px' },
    { title: deTableForm.field4Name??'欄位4', key: 'field4', minWidth: '150px' },
  ])


  // Data table options
  const deSelectCurrentPage = ref(1)
  const deSelectSize = ref(10)
  const deSelectSortOrder = ref()
  const deSelectOrderByCol = ref()

// Update data table options
  const deSelectUpdateOptions = (options: any) => {
      deSelectSortOrder.value = options.sortBy[0]?.key
      deSelectOrderByCol.value = options.sortBy[0]?.order
  }

// champ 後端分頁是從 0 開始
  const deSelectPage = computed((): number => deSelectCurrentPage.value - 1)
  const deSelectSelectTable = ref<string[]>([])

// 👉 Fetching details
  const { data: deSelectsData, execute: fetchDeSelects } = await useApi<any>(createUrl('/de/select/table/searchDeSelect', {
    query: {
      tabId,compId,
      page: deSelectPage,
      size: deSelectSize,
      orderByCol: deSelectOrderByCol,
      sortOrder: deSelectSortOrder,
    },
  }))
  const grid2Datas = computed((): De23Properties[] => {
    if (!deSelectsData.value) return []
    return deSelectsData.value.data.deSelectPage.content.map((item: De23Properties, index: number) => ({...item, uniqueKey: `row${index}`}))
  })
  const deSelectDatasTable =ref<De23Properties[]>(structuredClone(grid2Datas.value))
  const deSelectTotalDatas = computed(() => {
      if (!deSelectsData.value) return 0
      return deSelectsData.value.data.deSelectPage.totalElements
  })

  watch(() => grid2Datas.value,()=>{
      deSelectDatasTable.value.splice(0 , deSelectDatasTable.value.length , ...grid2Datas.value)
      deSelectSelectTable.value = []
  })

  // 判斷是否為新增資料>加上class 為元素
  const isDeSelectActiveNew = (uniqueKey: string) =>{
    return uniqueKey.includes('addNewRow-')
  }
// 用來存儲當前正在編輯的行的uniqueKey
  const editingDeSelectIndex = ref<string>('');
// 判斷是否正在編輯(text or inputField)
  const isDeSelectEditing = (uniqueKey: string) => editingDeSelectIndex.value === uniqueKey;
// 點擊時啟動編輯模式
  const enableDeSelectEdit = (uniqueKey: string ) => {
    editingDeSelectIndex.value = uniqueKey; // 設置當前編輯行的索引

    if(deSelectSelectTable.value.length>0){
      let isExist = deSelectSelectTable.value.includes(uniqueKey)
      if(!isExist){
          deSelectSelectTable.value.push(uniqueKey)
      }
    }else{
        deSelectSelectTable.value.push(uniqueKey)
    }
  };
// 結束編輯模式
  const disableDeSelectEdit = (uniqueKey: string) => {
    editingDeSelectIndex.value = ''; // 清空編輯uniqueKey
  };


  // 增列
  const addNewNumber  = ref(0)
  const createDataInTable = ()=>{
    addNewNumber.value++
    let uniqueKeyNew = `addNewRow-${addNewNumber.value}`
    let data = { ...deSelectForm, uniqueKey: uniqueKeyNew, doInsert: true }
    data.tabId = tabId.value
    deSelectDatasTable.value.push(data)
    editingDeSelectIndex.value = uniqueKeyNew
    if(deSelectSelectTable.value.length>0){
      let isExist = deSelectSelectTable.value.includes(uniqueKeyNew)
      if(!isExist){
          deSelectSelectTable.value.push(uniqueKeyNew)
      }
    }else{
        deSelectSelectTable.value.push(uniqueKeyNew)
    }
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'  // 這個選項讓滾動更平滑
    });
  }

  const removeDeSelects = () => {
    const arr = deSelectSelectTable.value
            .map((selestItem) => {
              //console.log('selestItem: ', selestItem)
              const { uniqueKey, ...rest } = deSelectDatasTable.value.find((item) => item.uniqueKey === selestItem) || {};
              return rest;
            })
            .filter((item): item is De23Properties => item && 'doInsert' in item); // 過濾掉 undefined 項並確保類型正確
    //console.log(arr);
    const deSelects: De23Properties[] = arr.filter(item => !item.doInsert);
    if(deSelects.length>0){
      deleteDeSelects(deSelects)
    }
  };

  const saveDeSelects = () => {
    const arr = deSelectSelectTable.value
            .map((selestItem) => {
              //console.log('selestItem: ', selestItem)
              const { uniqueKey, ...rest } = deSelectDatasTable.value.find((item) => item.uniqueKey === selestItem) || {};
              return rest;
            })
            .filter((item): item is De23Properties => item && 'doInsert' in item); // 過濾掉 undefined 項並確保類型正確
    //console.log(arr);
    const newDeSelects: De23Properties[] = arr.filter(item => item.doInsert);
    const updateDeSelects: De23Properties[] = arr.filter(item => !item.doInsert);

    if (newDeSelects.length > 0) {
      addNewDeSelectDatas(newDeSelects);
    }
    if(updateDeSelects.length>0){
      updateDeSelectDatas(updateDeSelects)
    }
  };

  const addNewDeSelectDatas = async (deSelectData: De23Properties[]) => {
    await $api('/de/select/table/createDeSelect', {
      method: 'POST',
      body: { deSelects: deSelectData },
    }).then(() => {
        $swal({
        position: 'top-end',
        icon: 'success',
        title: '新增成功',
        showConfirmButton: false,
        timer: 1500,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    })

    // refetch data
    fetchDeSelects()
  }

  const updateDeSelectDatas = async (deSelectData: De23Properties[]) => {
    await $api('/de/select/table/updateDeSelect', {
      method: 'PUT',
      body: { deSelects: deSelectData },
    }).then(() => {
        $swal({
        position: 'top-end',
        icon: 'success',
        title: '修改成功',
        showConfirmButton: false,
        timer: 1500,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    })

    // refetch data
    fetchDeSelects()
  }

  const deleteDeSelects = async (deSelectData: De23Properties[]) => {
    await $api(`/de/select/table/deleteDeSelect`, {
      method: 'DELETE',
      body: { deSelects: deSelectData }
    }).then(() => {
        $swal({
        position: 'top-end',
        icon: 'success',
        title: "刪除成功",
        showConfirmButton: false,
        timer: 1500,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    })
    // refetch data
    fetchDeSelects()
  }



</script>

<template>
  <VCard flat>
    <VCardItem>
      <VForm
        ref="refForm"
        v-model="isFormValid"
        @submit.prevent="onSubmit"
      >
        <VCardText class="d-flex flex-wrap gap-2">
          <VSpacer />

          <div class="app-user-search-filter d-flex align-center flex-wrap gap-4">
            <VBtn
               variant="outlined"
               @click="goBack"
            >
              返回
            </VBtn>
            <!-- 👉 delete button -->
            <VBtn
               variant="outlined"
               @click="deleteDeTableData"
               :disabled="tabId == 'newData'"
            >
              刪除
            </VBtn>
            <!-- 👉 Add button -->
            <VBtn
               type="submit"
            >
              儲存上方資料
            </VBtn>
          </div>
        </VCardText>
        <VDivider />
        <VCardText>
            <!-- 👉 Form -->
              <VRow>
                  <VCol cols="4">
                      <VRow no-gutters>
                          <!-- 👉 First Name -->
                          <VCol
                             cols="2"
                             md="2"
                             class="d-flex align-items-center"
                          >
                              <label
                                      class="v-label text-body-2 text-high-emphasis"
                                      for="tabId"
                              >表格編號</label>
                          </VCol>

                          <VCol
                                  cols="6"
                                  md="6"
                          >
                              <AppInput
                                  v-model="deTableForm.tabId"
                                  label=""
                                  type="text"
                                  item-title="label"
                                  item-value="value"
                                  placeholder="請輸入表格編號"
                                  :disabled="false"
                              />
                          </VCol>
                      </VRow>
                  </VCol>
                
                  <VCol cols="4">
                      <VRow no-gutters>
                          <!-- 👉 First Name -->
                          <VCol
                             cols="2"
                             md="2"
                             class="d-flex align-items-center"
                          >
                              <label
                                      class="v-label text-body-2 text-high-emphasis"
                                      for="tabName"
                              >表格名稱</label>
                          </VCol>

                          <VCol
                                  cols="6"
                                  md="6"
                          >
                              <AppInput
                                  v-model="deTableForm.tabName"
                                  label=""
                                  type="text"
                                  item-title="label"
                                  item-value="value"
                                  placeholder="請輸入表格名稱"
                                  :disabled="false"
                              />
                          </VCol>
                      </VRow>
                  </VCol>
                
                  <VCol cols="4">
                      <VRow no-gutters>
                          <!-- 👉 First Name -->
                          <VCol
                             cols="2"
                             md="2"
                             class="d-flex align-items-center"
                          >
                              <label
                                      class="v-label text-body-2 text-high-emphasis"
                                      for="tabComment"
                              >註解</label>
                          </VCol>

                          <VCol
                                  cols="6"
                                  md="6"
                          >
                              <AppInput
                                  v-model="deTableForm.tabComment"
                                  label=""
                                  type="text"
                                  item-title="label"
                                  item-value="value"
                                  placeholder="請輸入註解"
                                  :disabled="false"
                              />
                          </VCol>
                      </VRow>
                  </VCol>
                
                  <VCol cols="4">
                      <VRow no-gutters>
                          <!-- 👉 First Name -->
                          <VCol
                             cols="2"
                             md="2"
                             class="d-flex align-items-center"
                          >
                              <label
                                      class="v-label text-body-2 text-high-emphasis"
                                      for="field1Name"
                              >欄位一</label>
                          </VCol>

                          <VCol
                                  cols="6"
                                  md="6"
                          >
                              <AppInput
                                  v-model="deTableForm.field1Name"
                                  label=""
                                  type="text"
                                  item-title="label"
                                  item-value="value"
                                  placeholder="請輸入欄位一"
                                  :disabled="false"
                              />
                          </VCol>
                      </VRow>
                  </VCol>
                
                  <VCol cols="4">
                      <VRow no-gutters>
                          <!-- 👉 First Name -->
                          <VCol
                             cols="2"
                             md="2"
                             class="d-flex align-items-center"
                          >
                              <label
                                      class="v-label text-body-2 text-high-emphasis"
                                      for="field2Name"
                              >欄位二</label>
                          </VCol>

                          <VCol
                                  cols="6"
                                  md="6"
                          >
                              <AppInput
                                  v-model="deTableForm.field2Name"
                                  label=""
                                  type="text"
                                  item-title="label"
                                  item-value="value"
                                  placeholder="請輸入欄位二"
                                  :disabled="false"
                              />
                          </VCol>
                      </VRow>
                  </VCol>
                
                  <VCol cols="4">
                      <VRow no-gutters>
                          <!-- 👉 First Name -->
                          <VCol
                             cols="2"
                             md="2"
                             class="d-flex align-items-center"
                          >
                              <label
                                      class="v-label text-body-2 text-high-emphasis"
                                      for="field3Name"
                              >欄位三</label>
                          </VCol>

                          <VCol
                                  cols="6"
                                  md="6"
                          >
                              <AppInput
                                  v-model="deTableForm.field3Name"
                                  label=""
                                  type="text"
                                  item-title="label"
                                  item-value="value"
                                  placeholder="請輸入欄位三"
                                  :disabled="false"
                              />
                          </VCol>
                      </VRow>
                  </VCol>
                
                  <VCol cols="4">
                      <VRow no-gutters>
                          <!-- 👉 First Name -->
                          <VCol
                             cols="2"
                             md="2"
                             class="d-flex align-items-center"
                          >
                              <label
                                      class="v-label text-body-2 text-high-emphasis"
                                      for="field4Name"
                              >欄位四</label>
                          </VCol>

                          <VCol
                                  cols="6"
                                  md="6"
                          >
                              <AppInput
                                  v-model="deTableForm.field4Name"
                                  label=""
                                  type="text"
                                  item-title="label"
                                  item-value="value"
                                  placeholder="請輸入欄位四"
                                  :disabled="false"
                              />
                          </VCol>
                      </VRow>
                  </VCol>
                
              </VRow>
          </VCardText>
      </VForm>
    </VCardItem>
  </VCard>
  <VDivider />

  <VCard class="mb-6">
    <VCardTitle>
      簡易共用表格
    </VCardTitle>
    <VCardText class="d-flex flex-wrap gap-4">
      <VBtn
              class="mr-2"
              :disabled="tabId == 'newData'"
              @click="saveDeSelects"
      >
        儲存表格資料
      </VBtn>
      <VBtn
              variant="outlined"
              :disabled="tabId == 'newData'"
              @click="removeDeSelects"
      >
        刪除表格資料
      </VBtn>
      <VSpacer />

      <div class="app-user-search-filter d-flex align-center flex-wrap gap-4">
        <!-- 👉 Add button -->
        <VBtn
                prepend-icon="tabler-plus"
                @click="createDataInTable"
                :disabled="tabId == 'newData'"
                variant="tonal"
        >
          加入表格資料
        </VBtn>
      </div>
    </VCardText>

    <VDivider />

    <!-- SECTION datatable -->
    <VDataTableServer
            v-model="deSelectSelectTable"
            v-model:items-per-page="deSelectSize"
            v-model:page="deSelectCurrentPage"
            :items="deSelectDatasTable"
            :items-length="deSelectTotalDatas"
            :headers="grid2Headers"
            class="text-no-wrap"
            @update:options="deSelectUpdateOptions"
            item-value="uniqueKey"
            show-select
    >

      <template #item.id="{ item, index }">
        <div class="text-body-1 text-high-emphasis">
          {{ index + 1 }}
        </div>
      </template>
      
      <template #item.field1="{ item }">
        <div v-if="!isDeSelectEditing(item.uniqueKey)" :class="{ 'show-add': isDeSelectActiveNew(item.uniqueKey) , 'h-100':true}">
          <div class="text-body-1 text-high-emphasis h-100" style="line-height:3" @click="enableDeSelectEdit(item.uniqueKey)">
              {{ toCode(item.field1) }}
          </div>
        
        </div>
        <AppInput
          v-else
          v-model="item.field1"
          label=""
          type="text"
          item-title="label"
          item-value="value"
          placeholder="請輸入欄位1"
          :disabled="null"
        />
      </template>
      
      <template #item.field2="{ item }">
        <div v-if="!isDeSelectEditing(item.uniqueKey)" :class="{ 'show-add': isDeSelectActiveNew(item.uniqueKey) , 'h-100':true}">
          <div class="text-body-1 text-high-emphasis h-100" style="line-height:3" @click="enableDeSelectEdit(item.uniqueKey)">
              {{ toCode(item.field2) }}
          </div>
        
        </div>
        <AppTextarea
          v-else
          v-model="item.field2"
          label=""
          placeholder="請輸入欄位2"
          :disabled="null"
          auto-grow
          rows="1"
        />
      </template>
      
      <template #item.field3="{ item }">
        <div v-if="!isDeSelectEditing(item.uniqueKey)" :class="{ 'show-add': isDeSelectActiveNew(item.uniqueKey) , 'h-100':true}">
          <div class="text-body-1 text-high-emphasis h-100" style="line-height:3" @click="enableDeSelectEdit(item.uniqueKey)">
              {{ toCode(item.field3) }}
          </div>
        
        </div>
        <AppTextarea
          v-else
          v-model="item.field3"
          label=""
          placeholder="請輸入欄位3"
          :disabled="null"
          auto-grow
          rows="1"
        />
      </template>
      
      <template #item.field4="{ item }">
        <div v-if="!isDeSelectEditing(item.uniqueKey)" :class="{ 'show-add': isDeSelectActiveNew(item.uniqueKey) , 'h-100':true}">
          <div class="text-body-1 text-high-emphasis h-100" style="line-height:3" @click="enableDeSelectEdit(item.uniqueKey)">
              {{ toCode(item.field4) }}
          </div>
        
        </div>
        <AppInput
          v-else
          v-model="item.field4"
          label=""
          type="number"
          item-title="label"
          item-value="value"
          placeholder="請輸入欄位4"
          :disabled="null"
        />
      </template>
      
      <!-- pagination -->
      <template #bottom>
        <TablePagination
                v-model:page="deSelectCurrentPage"
                v-model:size="deSelectSize"
                :items-per-page="deSelectSize"
                :total-items="deSelectTotalDatas"
        />
      </template>
    </VDataTableServer>
    <!-- SECTION -->
  </VCard>

</template>
